import React, { useCallback, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
// import Button from '@material-ui/core/Button';
import CallMadeIcon from '@material-ui/icons/CallMade';

// import { AppContext } from '../../common/contexts';
// import {
//     ADMIN_JOB_SEEKER_REGISTRATIONS,
//     ADMIN_EMPLOYER_REGISTRATIONS,
//     ADMIN_ADVERTISEMENT_REQUESTS,
//     ADMIN_ACCOUNT_DELETIONS,
//     ADMIN_SURVEY_RESPONSES,
//     ADMIN_SUBSCRIPTION_CANCELLATIONS,
//     ADMIN_GOOGLE_ANALYTICS,
//     ADMIN_PRE_LAUNCH_PAGE,
//     ADMIN_CONTACT_US,
//     ADMIN_ACTIVITY_STATS,
// } from '../../common/constants';

import _get from 'lodash/get';

const styles = theme => ({
    unselected: {
        color: '#9B9E9C',
        cursor: 'pointer',
        '&:hover': {
            fontWeight: 500,
            color: 'black',
        },
    },
    selected: {
        color: '#111E14',
        cursor: 'pointer',
        fontWeight: 500,
        '&:hover': {
            background: 'rgba(0, 0, 0, 0.04)',
            color: 'black',
            borderRadius: '4px',
        },
    },
    contents: {
        display: 'flex',
        flexWrap: 'wrap',
        fontFamily: 'Roboto, sans-serif',
    },
    icon: {
        padding: '6px 8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        '&:hover': {
            background: 'rgba(0, 0, 0, 0.04)',
            color: 'black',
            borderRadius: '4px',
        },
    },
    label: {
        width: '100%',
    },
    caption: {
        width: '24px',
        height: '24px',
        borderRadius: '100%',
        background: '#fc821f',
        fontSize: '13px',
        color: '#ffffff',
        fontWeight: 'bold',
        marginLeft: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    captionText: { marginTop: '-1px' },
    iconAndCaptionContainer: { display: 'flex' },
});

const getIcon = props => {
    const label = _get(props, 'label', '');
    const selected = _get(props, 'selected', false);

    const color = selected ? 'inherit' : 'disabled';

    return label ? <span color={color}>{label}</span> : null;

    // switch (label) {
    //     case ADMIN_JOB_SEEKER_REGISTRATIONS:
    //         return <span color={color}>{ADMIN_JOB_SEEKER_REGISTRATIONS}</span>;
    //     case ADMIN_EMPLOYER_REGISTRATIONS:
    //         return <span color={color}>{ADMIN_EMPLOYER_REGISTRATIONS}</span>;
    //     case ADMIN_ADVERTISEMENT_REQUESTS:
    //         return <span color={color}>{ADMIN_ADVERTISEMENT_REQUESTS}</span>;
    //     case ADMIN_ACCOUNT_DELETIONS:
    //         return <span color={color}>{ADMIN_ACCOUNT_DELETIONS}</span>;
    //     case ADMIN_SURVEY_RESPONSES:
    //         return <span color={color}>{ADMIN_SURVEY_RESPONSES}</span>;
    //     case ADMIN_SUBSCRIPTION_CANCELLATIONS:
    //         return <span color={color}>{ADMIN_SUBSCRIPTION_CANCELLATIONS}</span>;
    //     case ADMIN_GOOGLE_ANALYTICS:
    //         return <span color={color}>{ADMIN_GOOGLE_ANALYTICS}</span>;
    //     case ADMIN_PRE_LAUNCH_PAGE:
    //         return <span color={color}>{ADMIN_PRE_LAUNCH_PAGE}</span>;
    //     case ADMIN_CONTACT_US:
    //         return <span color={color}>{ADMIN_CONTACT_US}</span>;
    //     case ADMIN_ACTIVITY_STATS:
    //         return <span color={color}>{ADMIN_ACTIVITY_STATS}</span>;

    //     default:
    //         return null;
    // }
};

const AdminNavigationButton = props => {
    // const appContext = useContext(AppContext);
    const [isShown, setIsShown] = useState(false);
    const { classes, selected, onClick, caption, isCaption } = props;

    const rootClassName = selected ? classes.selected : classes.unselected;

    const handleClickButton = useCallback(() => {
        if (onClick) onClick();
    }, [onClick]);

    return (
        <span className={rootClassName} onClick={handleClickButton}>
            <p className={classes.icon} onMouseEnter={() => setIsShown(true)} onMouseLeave={() => setIsShown(false)}>
                <div className={classes.iconAndCaptionContainer}>
                    {getIcon(props)}
                    {isCaption && (
                        <div className={classes.caption}>
                            <span className={classes.captionText}>{caption}</span>
                        </div>
                    )}
                </div>
                {isShown && (
                    <div>
                        <CallMadeIcon style={{ fontSize: '10px' }} />
                    </div>
                )}
            </p>
        </span>
    );
};

export default withStyles(styles)(AdminNavigationButton);
